import { ShieldAlert, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@src/presentation/contexts/AuthContext";
import { Button, Card, CardBody } from "@heroui/react";

const Unauthorized = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
            <Card className="max-w-md w-full shadow-none border border-border rounded">
                <CardBody className="text-center p-8">
                    <div className="flex justify-center mb-4">
                        <div className="p-3 rounded-full bg-danger/10">
                            <ShieldAlert className="h-12 w-12 text-danger" />
                        </div>
                    </div>

                    <h2 className="text-xl font-semibold text-foreground mb-2">
                        Access Denied
                    </h2>

                    <p className="text-default-500 mb-6">
                        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
                    </p>

                    <div className="flex flex-col gap-2">
                        <Button
                            color="primary"
                            onPress={() => navigate('/')}
                            className="rounded"
                        >
                            Go to Dashboard
                        </Button>
                        <Button
                            variant="flat"
                            onPress={() => navigate(-1)}
                            className="rounded"
                        >
                            Go Back
                        </Button>
                        <Button
                            variant="flat"
                            color="danger"
                            onPress={() => {
                                logout();
                                navigate('/auth');
                            }}
                            startContent={<LogOut className="h-4 w-4" />}
                            className="rounded"
                        >
                            Logout
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default Unauthorized;
